import type { FC, ReactNode } from 'react';

import { TextLink } from '@eneco/sparky';

import { useChat } from './useChat';

interface Props {
  'data-chattopic': string;
  'data-displaytext': string;
  'data-senddisplaytext': string;
  children?: ReactNode;
}

const ChatLinkButton: FC<Props> = ({
  'data-chattopic': topic,
  'data-displaytext': askText,
  'data-senddisplaytext': sendTopicAndAskText,
  children,
}) => {
  const [mount] = useChat();
  return (
    <TextLink
      onClick={() =>
        mount({ visibility: 'open', topic, askText, sendTopicAndAskText: sendTopicAndAskText === 'true' })
      }>
      {children}
    </TextLink>
  );
};

export default ChatLinkButton;
